import { useMemo } from 'react';
import { useQueryBonuses } from './useQueryBonuses';
import { AVAILABLE } from '../../constants/bonuses';

export const useCurrentBonuses = (queryOptions = {}) => {
  const { data, ...props } = useQueryBonuses(queryOptions);

  const resultData = useMemo(
    () =>
      data.reduce(
        (acc, item) => {
          if (item.isCampaign && item.status === AVAILABLE) {
            acc.available.push(item);
          } else {
            acc.active.push(item);
          }

          return acc;
        },
        { active: [], available: [] }
      ),
    [data]
  );

  return { ...props, data: resultData };
};
